<div class="number-input-container">
  @if (negative) {
  <div class="value-container negative">
    @for (value of stepsNegative; track value) {
    <div tabclick [ngClass]="{'disabled' : min &&  model - value < min}" class="value" (click)="change(-value)">
      {{(relative ? -value : (model - value)) | ghsValueSign}}
    </div>
    }
  </div>
  }
  <div class="current">
    @if (relative) {
    <span>{{model}}</span>
    }
    @if (!relative) {
    <span>{{model | ghsValueSign}}</span>
    }
  </div>
  <div class="value-container">
    @for (value of steps; track value) {
    <div tabclick [ngClass]="{'disabled' : max && model + value > max}" class="value" (click)="change(value)">
      {{(relative ? value : (model + value)) | ghsValueSign}}
    </div>
    }
  </div>
</div>